import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FilterHeaderComponent } from '../filter-header/filter-header.component';
import { BaseFilterComponent } from '../filter/base-filter.component';

@Component({
  selector: 'vectronic-map-fix-type-filter',
  templateUrl: './map-fix-type-filter.component.html',
  styleUrls: ['../single-select-dropdown/single-select-filter.component.scss'],
  imports: [FilterHeaderComponent, MatSelectModule, MatFormFieldModule, ReactiveFormsModule],
})
export class MapFixTypeFilterComponent extends BaseFilterComponent implements OnInit {
  fixTypeModeList = this.filterList.mapFixTypeModeList;

  override ngOnInit() {
    super.ngOnInit();
    this.filtersForm()?.get(this.filterEnableControl())?.setValue(true, { emitEvent: false });
    this.isFilterHidden.set(true);
  }
}
